import * as _ from "lodash";

import { formatDate } from "../date";
import { ROLE_NAMES, ROLE_TYPES } from "./constants";
import type {
  ChatConversation,
  ChatMessage,
  Role,
  SetUnreadMessagesType,
} from "./types";

export const conversationSorter = (a: ChatConversation, b: ChatConversation) =>
  (b.lastMessage?.dateCreated?.getTime() ?? b.dateUpdated?.getTime() ?? 0) -
  (a.lastMessage?.dateCreated?.getTime() ?? a.dateUpdated?.getTime() ?? 0);

export const getTypingMessage = (typingData: string[]): string =>
  typingData.length > 1
    ? `${typingData.length + " participants are typing..."}`
    : `${typingData[0] + " is typing..."}`;

export function getLastMessage(messages: ChatMessage[], typingData: string[]) {
  if (messages === undefined || messages === null) {
    return "Loading...";
  }
  if (typingData.length) {
    return getTypingMessage(typingData);
  }
  if (messages.length === 0) {
    return "No messages";
  }
  return messages[messages.length - 1]?.body || "Media message";
}

export function isMyMessage(messages: ChatMessage[], identity: string) {
  if (messages === undefined || messages === null || messages.length === 0) {
    return false;
  }
  return messages[messages.length - 1]?.author === identity
    ? messages[messages.length - 1]
    : false;
}

export function getLastMessageTime(messages: ChatMessage[]) {
  const lastMessageDate = _.last(messages)?.dateCreated;

  if (!lastMessageDate) {
    return "";
  }

  return formatDate(lastMessageDate.toISOString());
}

export function setUnreadMessagesCount(
  currentconvoSid: string,
  convoSid: string,
  unreadMessages: Record<string, number>,
  updateUnreadMessages: SetUnreadMessagesType,
) {
  if (currentconvoSid == convoSid && unreadMessages[convoSid] !== 0) {
    updateUnreadMessages(convoSid, 0);
    return 0;
  }
  if (currentconvoSid == convoSid) {
    return 0;
  }
  return unreadMessages[convoSid];
}

export function isUserChannelAdmin(
  userRoleSid: string,
  roles: Role[],
): boolean {
  const channelAdminRole = roles
    .filter((role) => role.type === ROLE_TYPES.CONVERSATION)
    .find((role) => role.friendlyName === ROLE_NAMES.CHANNEL_ADMIN);
  return userRoleSid === channelAdminRole?.sid;
}
